module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-1600-6821d37e1ed096a2901ab0c3a28d51fa.jpg";